export const TRANSLATION_ENG = {
  success: {
    headerText: "We've retrieved your Myinfo with Singpass",
    sectionText: 'You can proceed with the next step in your HSBC app.',
    hsbcLogoAlt: 'HSBC Logo',
    buttonText: 'Continue in HSBC app'
  },
  error: {
    headerText: "You've canceled to retrieve your Myinfo with Singpass",
    sectionText: 'You can come back later...',
    hsbcLogoAlt: 'HSBC Logo',
    buttonText: 'Continue in HSBC app'
  }
};
